/**
 * 프로그램 스코프 행: 이번 탭에서 해당 스코프 identity로 **Supabase 조회에 성공한 뒤**에만 표시(sessionStorage).
 * - identity는 `workspaceId|academicYear|termNumber|gradeId|scopeType|scopeKey` 형태이며,
 *   DB `program_scoped_content_rows`는 동일 키(학기는 `term_number`)로 필터된다. 학기·편제마다 identity가 달라진다.
 * - LS만 읽었다고 여기에 넣지 않는다(학기 전환 시 빈/꼬인 LS가 «검증됨»으로 남아 소프트 경로만 타는 버그 방지).
 *   `useProgramScopedContentRows`는 LS로는 즉시 그리되, 이 플래그는 네트워크 응답 후에만 켠다.
 * - 탭을 닫기 전까지 유지되며 F5 후에도 남아 같은 스코프는 이후 LS만으로 재조회할 수 있다.
 * - 전역 초기화는 로그아웃 시 `clearProgramScopedScopeServerValidatedRegistry()` 등.
 */

const STORAGE_KEY = 'cp:programScopedRowsServerValidated:v1';

function parseSet(raw: string | null): Set<string> {
  if (!raw) return new Set();
  try {
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === 'string' && x.length > 0));
  } catch {
    return new Set();
  }
}

function readSet(): Set<string> {
  if (typeof window === 'undefined') return new Set();
  return parseSet(sessionStorage.getItem(STORAGE_KEY));
}

function writeSet(s: Set<string>): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(s)));
  } catch {
    /* quota / private mode */
  }
}

export function isProgramScopedScopeServerValidated(identity: string): boolean {
  return readSet().has(identity);
}

export function markProgramScopedScopeServerValidated(identity: string): void {
  if (!identity.trim()) return;
  const s = readSet();
  if (s.has(identity)) return;
  s.add(identity);
  writeSet(s);
}

/** LS 스냅샷이 다른 스코프로 꼬였을 때만 검증 표시 제거 → 다음 조회에서 서버로 맞춤 */
export function revokeProgramScopedScopeServerValidated(identity: string): void {
  if (!identity.trim()) return;
  const s = readSet();
  if (!s.has(identity)) return;
  s.delete(identity);
  writeSet(s);
}

export function clearProgramScopedScopeServerValidatedRegistry(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* */
  }
}
